const loginForm = document.querySelector('.customer-login-form');
const forgotForm = document.querySelector('.customer-forgot-form');
const forgotLink = document.querySelector('.forgot-link');
const loginLink = document.querySelector('.login-link');

if(forgotLink) {
  forgotLink.addEventListener('click', (e) => {
    e.stopPropagation();
    forgotForm.classList.remove('hidden');
    forgotForm.classList.add('flex');
    loginForm.classList.remove('flex');
    loginForm.classList.add('hidden');
  });
}

if(loginLink) {
  loginLink.addEventListener('click', (e) => {
    e.stopPropagation()
    loginForm.classList.remove('hidden');
    loginForm.classList.add('flex');
    forgotForm.classList.remove('flex');
    forgotForm.classList.add('hidden');
  });
}

const swiper = new Swiper('.swiper', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  autoplay: {
    delay: 3000,
  },
  speed: 1000,
});